import { render, staticRenderFns } from "./specialized-new-zone-announcement.vue?vue&type=template&id=365695d2&scoped=true"
import script from "./specialized-new-zone-announcement.vue?vue&type=script&lang=js"
export * from "./specialized-new-zone-announcement.vue?vue&type=script&lang=js"
import style0 from "./specialized-new-zone-announcement.vue?vue&type=style&index=0&id=365695d2&prod&lang=css"
import style1 from "./specialized-new-zone-announcement.vue?vue&type=style&index=1&id=365695d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365695d2",
  null
  
)

export default component.exports